import { render, staticRenderFns } from "./ProcessSafeTic.vue?vue&type=template&id=24d0de1b&scoped=true"
import script from "./ProcessSafeTic.vue?vue&type=script&lang=js"
export * from "./ProcessSafeTic.vue?vue&type=script&lang=js"
import style0 from "./ProcessSafeTic.vue?vue&type=style&index=0&id=24d0de1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0de1b",
  null
  
)

export default component.exports